<div class="mmx-action-card" [class.selected]="selected">
  <ng-content></ng-content>

  <div class="mmx-action-card-actions">
    <button *ngIf="selected; else selectText" mat-raised-button color="primary" (click)="unselect()">
      {{ 'common.selected' | translate }}
      <mat-icon>check</mat-icon>
    </button>
    <ng-template #selectText>
      <button mat-raised-button color="primary" (click)="select()">
        {{ 'common.select' | translate }}
      </button>
    </ng-template>
  </div>
</div>
